import api from "./api";

export type AccountLedger = {
  id: string;
  code: string;
  name: string;
  isSystem: boolean;
  isActive: boolean;
};

export type LedgerGroup = {
  id: string;
  code: string;
  name: string;
  nature: string;
  sortOrder: number;
  isSystem: boolean;
  ledgers: AccountLedger[];
};

const chartOfAccountsAPI = {
  list: async (): Promise<LedgerGroup[]> => {
    const res = await api.get("/chart-of-accounts");
    const payload = res.data?.data;
    if (Array.isArray(payload)) return payload;
    return payload?.groups || [];
  },
};

export default chartOfAccountsAPI;
